var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticClass: "close-reason-dialog",
      attrs: {
        title: _vm.as_number,
        width: "30%",
        "append-to-body": true,
        visible: _vm.closeDialogVisible
      },
      on: {
        "update:visible": function($event) {
          _vm.closeDialogVisible = $event
        }
      }
    },
    [
      _c("span", [_vm._v("关闭理由：")]),
      _vm._v(" "),
      _c("el-input", {
        model: {
          value: _vm.closeReason,
          callback: function($$v) {
            _vm.closeReason = $$v
          },
          expression: "closeReason"
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            {
              attrs: { size: "small" },
              on: {
                click: function($event) {
                  _vm.closeDialogVisible = false
                }
              }
            },
            [_vm._v("取 消")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "small" },
              on: { click: _vm.confrimClose }
            },
            [_vm._v("确 定")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-69c11e40", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69c11e40","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bigAftersale/close-reason-dialog.vue
// module id = null
// module chunks = 